// extracted by mini-css-extract-plugin
module.exports = {"firstCell":"AssetCell_firstCell__1Ca3T","imageContainer":"AssetCell_imageContainer__3lxeb","title":"AssetCell_title__2jONN","subtitle":"AssetCell_subtitle__2Pk4y"};